export const UpdateShipment = function (updateFormData, timeOutValue) {
  return new Promise(function (resolve, reject) {
    let controller = new AbortController();
    let signal = controller.signal;
    let url =
      "https://www2.shippersedge.com/public/consignee/consigneePortal.cfm?wsdl";
    let request = new Request(url, {
      method: "POST",
      signal,
      body: updateFormData,
    });
    setTimeout(() => controller.abort(), timeOutValue);
    fetch(request)
      .then((response) => {
        //   console.log("debug UpdateShipmentStatus response", response);
        if (!response.ok) {
          console.error(
            "UpdateShipment.js error",
            response.statusText,
            response
          );
          throw Error(response.statusText);
        }

        return response.json();
      })
      .then((response) => {
        resolve(response.message);
      })
      .catch((err) => {
        console.error("UpdateShipment API Request failed", err);
        resolve("Aborted");
      });
  });
};
